var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHn = function SvgHn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 23.999a12 12 0 0 0 10.809-6.783H1.19A12 12 0 0 0 12 24ZM12-.001A12 12 0 0 0 1.192 6.782H22.81A12 12 0 0 0 12-.001ZM7.385 7.824l.389 1.196H9.03l-1.017.74.388 1.195-1.017-.74-1.017.74.388-1.196L5.74 9.02h1.257l.389-1.196ZM7.385 13.043l.389 1.195H9.03l-1.017.74.388 1.195-1.017-.74-1.017.74.388-1.196-1.017-.739h1.257l.389-1.195ZM16.614 7.824l.39 1.196h1.256l-1.017.74.389 1.195-1.018-.74-1.017.74.389-1.196-1.017-.739h1.257l.389-1.196ZM16.614 13.043l.39 1.195h1.256l-1.017.74.389 1.195-1.018-.74-1.017.74.389-1.196-1.017-.739h1.257l.389-1.195ZM12 10.433l.388 1.196h1.257l-1.017.74.389 1.195-1.018-.74-1.017.74.389-1.196-1.018-.739h1.258l.388-1.196Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHn;